import React, { useContext, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useUpdateFieldsTable } from '@/modules/AiAgents/apiHooks';
import { AIContext } from '@/modules/AiAgents/context/nugzContext/context';
import { AIActionsTypes } from '@/modules/AiAgents/context/nugzContext/reducer';
import { IAI } from '@/modules/AiAgents/types';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import CheckIcon from '~/images/shared/CheckWithoudBg.svg';

const SaveButton = () => {
  const { t } = useTranslation('common');
  const { dispatch } = useContext(AIContext);
  const [selectedAsset] = useStore((store) => store?.asset);
  const { mutate, isLoading: isSaveLoading } = useUpdateFieldsTable();
  const { watch } = useFormContext<IAI.IFieldsFormSchema>();
  const fields = watch('fields') || [];

  const handleSave = () => {
    if (selectedAsset) {
      mutate(
        {
          entityId: selectedAsset.id,
          data: {
            fields,
          },
        },
        {
          onSuccess: (data) => {
            dispatch({
              type: AIActionsTypes.setIsEditing,
              payload: false,
            });
            dispatch({
              type: AIActionsTypes.setIsLoading,
              payload: false,
            });
            dispatch({
              type: AIActionsTypes.setTableList,
              payload: data,
            });
          },
        }
      );
    }
  };

  useEffect(() => {
    dispatch({
      type: AIActionsTypes.setIsLoading,
      payload: isSaveLoading,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSaveLoading]);

  return (
    <div
      className='flex cursor-pointer items-center gap-1 rounded-xl bg-secondary-20 px-16 py-2 text-base font-semi-bold text-white'
      onClick={handleSave}
    >
      <span className='text-18'>
        <CheckIcon />
      </span>
      <span>{t('save')}</span>
    </div>
  );
};

export { SaveButton };
